import React, { createContext, useContext, useEffect, useState } from "react";
import { TRANSLATIONS } from "../data/translations";

const LanguageContext = createContext({ lang: "tr", setLang: () => {}, t: (k) => k });

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window !== "undefined") {
      const saved = localStorage.getItem("verasist-lang");
      if (saved === "tr" || saved === "en") return saved;
      return "tr";
    }
    return "tr";
  });

  useEffect(() => {
    localStorage.setItem("verasist-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => {
    const dict = TRANSLATIONS[lang] || TRANSLATIONS.tr;
    return dict[key] !== undefined ? dict[key] : (TRANSLATIONS.tr[key] || key);
  };

  const toggleLang = () => setLang((l) => (l === "tr" ? "en" : "tr"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
export const useT = () => {
  const { t } = useContext(LanguageContext);
  return t;
};
